import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers} from "./config";

const InventoryValueList = ({ category = 'values'}) => {

  return (
    <Table tableId={`inventory_values/${category}`} title="Inventory Value" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="attribute" idKey="inventory_value_id" NoTitle={true} />
  );
};

export default InventoryValueList;